import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit, ViewChildren, QueryList, OnDestroy, ViewChild } from '@angular/core';
import { MAINFILTER } from '../../models/MAINFILTER';
import { FiltersService } from '../../services/filters/filters.service';
import { CommonFilterService } from '../../services/common-filter/common-filter.service';
import { lastDateFunc, formatDate, formatDBTZDateToLocalDate } from 'lib/common/utils';
import * as moment from 'moment';
import { Router } from '@angular/router';
import { MatDialog, MatDialogConfig, MatAutocomplete, MatAutocompleteTrigger, PageEvent, MatPaginator } from '@angular/material';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-load-filter',
  templateUrl: './load-filter.component.html',
  styleUrls: ['./load-filter.component.scss']
})
export class LoadFilterComponent implements OnInit, AfterViewInit, OnDestroy {
  //@Input() isFilters: boolean;
  FilterOFF: boolean = true;
  FilterOFFNum: number = 0;
  nonFilterScreens: boolean;
  dtPeriod1: any;
  dtPeriod2: any;
  filtersList = [];
  filterNamesObservable = [];
  selectedFilters: number = 0;
  modifiedFilters: number = 0;
  modelFilterName: string;
  constructorLoad = false;
  ismainFilterEnabled: boolean = true; //true;
  @Output() RefreshClicked = new EventEmitter();

  toHighlight: string = '';
  insertedOrNot = false;
  constructor(private service: FiltersService, private commonFilterService: CommonFilterService, private router: Router) {
    this.commonFilterService.nonFilterScreen$.subscribe(res => {
      if (this.inputLengthFilter == 0)
        this.wrongFilter = false;
      this.nonFilterScreens = res;
    });

    this.commonFilterService.componentMethodCalled$.subscribe(res => {
      debugger;
      if (this.inputLengthFilter == 0)
        this.wrongFilter = false;
      if (this.FilterOFF) {
        //this.selectedFilters = 0;
        //this.constructorLoad = true;
        this.onFilterChange(null, true);
      }
      else {
        debugger;
        this.triggerCollection.forEach((x, i) => {
          if (i == 0) {
            const selMatOption = x.autocomplete.options.toArray();
            if (selMatOption.length > 0) {
              let filterSel = selMatOption.find((o) => o.value.CriteriaName === this.filterSelName);
              if (filterSel)
                this.controlFilter.setValue(filterSel.value);
            }
          }
        });
      }
    });

    this.commonFilterService.componentFilterMethodCalled$.subscribe(res => {
      //this.insertedOrNot = false;
      debugger;
      if (res == 3) {

        this.onFilterOFFClicked();//selected filter deleted so filter load should be off and selected filter should be null or default value

        //this.clearInputTextFilter();
        //////alert(this.selectedFilters);
        debugger;

        this.FilterOFF = true;
      }

      if (this.inputLengthFilter == 0)
        this.wrongFilter = false;
      //this.selectedFilters = 0;
      //this.constructorLoad = true;
      if (res == 1 || res == 3)
        this.onFilterChange(null, false);
      else if (res == 2)
        this.onFilterChange(this.modifiedFilters, false);//modified, so selected the same fitler
      //else if (res == 3)
      //  this.onFilterChange(null, true);

      if (res == 1)
        this.insertedOrNot = true;//created a new filter or a duplicate from selected filter, so refresh of main screen results avoided
    });
  }

  @ViewChildren(MatAutocompleteTrigger) triggerCollection: QueryList<MatAutocompleteTrigger>;
  @ViewChild('inputFilter', { static: false }) inputCtrl;

  controlFilter = new FormControl();

  @Input() myConfigNameFilter = "null";

  initFilter = false;
  ngOnInit() {

    if (this.myConfigNameFilter == "")
      this.myConfigNameFilter = "null";
    //////alert(5);

    if (!this.constructorLoad) {
      this.constructorLoad = false;
      this.selectedFilters = 0;
      this.onFilterChange(null, false);
    }

    this.controlFilter.valueChanges.subscribe(newValue => {
      this.filterNamesObservable = this._FilterName(newValue);
    })
  }
  ngOnDestroy() {
    setTimeout(() => {
      this.triggerCollection.forEach((x, i) => {
        x.closePanel();
      });
    }, 1000);
  }

  isLoading = false;
  interval;
  ngAfterViewInit() {

    if (this.myConfigNameFilter != "null") {
      this.isLoading = true;
      this.interval = setInterval(() => {
        this.triggerCollection.forEach((x, i) => {
          if (i == 0) {
            const selMatOption = x.autocomplete.options.toArray();
            if (selMatOption.length > 0) {
              let filterSel = selMatOption.find((o) => o.value.CriteriaName === this.myConfigNameFilter);
              if (filterSel)
                this.controlFilter.setValue(filterSel.value);
              clearInterval(this.interval);
            }
          }
        });
      }, 1000);
      this.isLoading = false;
    }
  }

  filterSelName = '';
  mainFilterCloseChk = false;
  onFilterChange(event, mainFilterClose, clearInput?): void {
    debugger;
    //if (this.FilterClose) {
    //  this.FilterClose = false;
    //  return;
    //}

    this.filterSelName = "";
    if (this.FilterOFF && event != null) {
      this.inputLengthFilter = 1;
      this.selectedFilters = parseInt(event);//IMP
      return;
    }
    //////alert(1);
    if (event == '-1') {//NEVER HAPPENS
      ////https://stackoverflow.com/questions/52936803/routing-a-page-using-material-select-and-routerlink-angular-6
      //this.router.navigateByUrl('/filters');

      //IMP
      this.router.navigate([{ outlets: { filterPopup: ['filters'], configPopup: null } }]);

      ///// when calling modify search set mainfilter to initial values
      this.commonFilterService.SetMainFilter(0);// set selected mainfilter id
      this.commonFilterService.SetMainFilterCriteriaName(''); //set mainfilter criterianame
      this.commonFilterService.setMFCustDT("");
      this.commonFilterService.setMFTZON(0);

      if (!this.insertedOrNot)
        this.RefreshClicked.emit();
    }
    else {

      this.commonFilterService.SetMainFilterCustomDate(false); // set false by default
      this.commonFilterService.setMFCustDT("");
      this.commonFilterService.setMFTZON(0);

      if (event == undefined || event == null) {//refresh ddl to latest list from db and reset all controls to default and fill ddl with filters
        this.getFilterConfig(0, '0', mainFilterClose);//this.getFilterConfig(0, '0');

        //this.selectedFilters = 0;

        if (this.selectedFilters != 0 && mainFilterClose == false && !this.FilterOFF) {
          this.SetCustomDatetime(this.selectedFilters);
        }
        //this.commonFilterService.setMFCustDT("");
        //this.commonFilterService.SetMainFilter(0);// set selected mainfilter id
        //if (!this.insertedOrNot)
        //this.RefreshClicked.emit();
      }
      else if (event !== undefined && event !== null) {//selected filter loads resp. criteria into controls and display saved tables
        this.setLimitedOptions = true;
        this.filterNamesObservable = this.filtersList;
        this.commonFilterService.SetMainFilterMapRegion('');
        debugger;
        let selID = parseInt(event);
        this.commonFilterService.SetMainFilter(selID);// set selected mainfilter id
        if (selID > 0) {
          let filterSel = this.filtersList.find(m => m.ID == selID);
          if (filterSel) {
            this.filterSelName = filterSel.CriteriaName;
            this.inputLengthFilter = this.filterSelName.length;
            this.commonFilterService.SetMainFilterCriteriaName(this.filterSelName); ////set mainfilter criterianame
            if (filterSel.MapRegion != "--Select Config--" && filterSel.MapRegion != '')
              this.commonFilterService.SetMainFilterMapRegion(filterSel.MapRegion); ////set mainfilter criterianame
          }
        }
        else {
          this.commonFilterService.SetMainFilterCriteriaName(''); //set mainfilter criterianame
          this.commonFilterService.SetMainFilterMapRegion('');
        }

        //this.commonFilterService.mainFilterID.subscribe(res => {
        //  //console.log(res)
        //});

        this.modifiedFilters = selID;

        /////below code is to check selected filter has custom datetime then set true/false accordinly elumalai
        if (selID > 0 && !this.FilterOFF) {
          let filterSelOff = this.filtersList.find(m => m.ID == selID);
          if (filterSelOff)
            this.filterSelName = filterSelOff.CriteriaName;
          this.SetCustomDatetime(selID);

          //let mainfilterCustDatetime = this.filtersList.find(m => m.ID == selID).CustDateTime;

          //if (mainfilterCustDatetime != ";") {
          //  this.commonFilterService.SetMainFilterCustomDate(true);// set true if selected mainfilter has customdate time

          //  this.commonFilterService.setMFCustDT(mainfilterCustDatetime);
          //  //this.commonFilterService.setDatesProperties(mainfilterCustDatetime.replace(';', '^'));///set in common filter control elumalai
          //}
          //else {

          //  this.commonFilterService.setMFCustDT("");

          //}

          ////////////////////////////
          //this.getFilterConfig(1, event);


          ////////// Set TimeZone
          //console.log(this.filtersList)
          //debugger;
          if (filterSelOff) {
            let isTimeZone = filterSelOff.Timezone;
            //console.log(isTimeZone)
            if (isTimeZone == 'False') {
              //this.GetTimeZoneDatePeriod(selID);
              this.commonFilterService.setMFTZON(0);
              this.commonFilterService.setDBAndBrowserHrsDiff(-500); ////if timezone is false then set default value as -500
            }
            else
              this.commonFilterService.setMFTZON(1);
          }
        }
        else {
          //////if maimfilter ddl is unselected then set datetime filter to  previous selected custom date time if any

          let selectedTime: any;
          selectedTime = { startDate: moment(), endDate: moment() };
          let custDates = "";//selectedTime.startDate.format('MM/DD/YYYY HH:mm:ss') + ' - ' + selectedTime.endDate.format('MM/DD/YYYY HH:mm:ss');//this.dateStartInput.nativeElement.value;
          this.commonFilterService.TSBetween.subscribe(res => custDates = res);
          //console.log(custDates);
          if (custDates == "")
            custDates = selectedTime.startDate.format('MM/DD/YYYY HH:mm:ss') + '^' + selectedTime.endDate.format('MM/DD/YYYY HH:mm:ss');
          //this.commonFilterService.setDatesProperties(custDates);
        }

        if (this.myConfigNameFilter == "null" && clearInput)
          this.OpenAutoCompeleteDailogFilter(clearInput);

        if (!this.insertedOrNot)
          this.RefreshClicked.emit();
      }
    }

    if (this.insertedOrNot)
      this.insertedOrNot = false;//reset after modify filters screen closed for ddl item changes later

  }

  SetCustomDatetime(selID) {
    //////alert(2);
    if (selID > 0) {
      let filterSel = this.filtersList.find(m => m.ID == selID);
      if (filterSel) {
        let mainfilterCustDatetime = filterSel.CustDateTime;

        if (mainfilterCustDatetime != ";") {
          let formateFromdt = formatDate(new Date(mainfilterCustDatetime.split(';')[0]));//, null, null);
          let formateTodt = formatDate(new Date(mainfilterCustDatetime.split(';')[1]));//, null, null);
          mainfilterCustDatetime = formateFromdt + ';' + formateTodt;

          this.commonFilterService.SetMainFilterCustomDate(true);// set true if selected mainfilter has customdate time

          this.commonFilterService.setMFCustDT(mainfilterCustDatetime);

          //this.commonFilterService.setDatesProperties(mainfilterCustDatetime.replace(';', '^'));
        }
        else {
          this.commonFilterService.SetMainFilterCustomDate(false);// set false if selected mainfilter doesnt has customdate time
          this.commonFilterService.setMFCustDT("");
        }
      }
      else {
        this.commonFilterService.SetMainFilterCustomDate(false);// set false if selected mainfilter doesnt has customdate time
        this.commonFilterService.setMFCustDT("");
      }

      ////////// Set TimeZone
      //let isTimeZone = this.filtersList.find(m => m.ID == selID).Timezone; 
      //if (isTimeZone == 'False') {
      //  this.GetTimeZoneDatePeriod(selID);
      //}

    }
  }

  getFilterConfig(type: number, FilterID: string, mainFilterClose: boolean) {
    ////alert(3);
    if (type == 0) {
      let filterNames = [];
      this.service.getConfigsList(type, FilterID).subscribe((res) => {
        //https://stackoverflow.com/questions/53275405/typeerror-data-foreach-is-not-a-function/53275463 - JSON.parse - IMP
        //const rows: any[] = JSON.parse(res) as any[] || [];
        let rows: any[] = JSON.parse(res) as any[] || [];
        debugger;
        ////////// check if user previlege configed any mainfilter or not
        if (sessionStorage.getItem('SystemSettings')) {
          this.ismainFilterEnabled = JSON.parse(sessionStorage.getItem('SystemSettings')).ismainFilterEnabled; /// commented by elumalai as ismainFilterEnabled is always true since this value(treu/false) is to check mainfilter is present in systemsettings or not.

          if (sessionStorage.getItem('SystemSettings') != null && JSON.parse(sessionStorage.getItem('SystemSettings')).mainFilterIDs != '') {
            let userConfigMainFilterIDs = JSON.parse(sessionStorage.getItem('SystemSettings')).mainFilterIDs.split(';');
            if (userConfigMainFilterIDs != null && userConfigMainFilterIDs.length > 0) {
              //rows = rows.filter(m => userConfigMainFilterIDs.includes(m.ID));
              let filteredRows = [];
              userConfigMainFilterIDs.forEach(item => {
                let itemRow = rows.filter(m => m.ID == item);
                filteredRows.push(itemRow[0]);
              });
              if (filteredRows.length > 0) {
                rows = filteredRows;
              }
            }
          }
        }
        ////////////////////

        rows.forEach(row => {
          filterNames.push({ ID: row.ID, CriteriaName: row.CriteriaName, CustDateTime: row.CustomDateTime, Timezone: row.Timezone, MapRegion: row.MapRegion });
        });
        // console.log('checkselectedFilters');
        // console.log(this.selectedFilters);        
        this.filtersList = filterNames;
        debugger;
        ///////if selected mainfilter is deleted in modify filter page then clear textbox
        if (this.selectedFilters > 0) {
          let recordExists = this.filtersList.find(m => m.ID == this.selectedFilters);
          if (!recordExists || recordExists==undefined)
            this.clearInputTextFilter();
        }

        this.getListFilter();
        //console.log(this.filtersList)
        if (mainFilterClose) {
          this.mainFilterCloseChk = true;
          this.onFilterChange(this.selectedFilters, false);
          //this.controlFilter.setValue(this.inputCtrl.nativeElement.value);
        }
      });//0 - binds configs on top, 1 - selected config details by its ID, 2 - Saved and fetched details immediately
    }
    else if (type == 1) {
      //this.filterIDSelected = parseInt(FilterID);

      this.service.getConfigsList(type, FilterID).subscribe((res) => {
        const rows: MAINFILTER[] = JSON.parse(res) as MAINFILTER[] || [];
        //debugger;
        //console.log(rows)
        ////////// Set/ maintain custom date after main filter selection // below code will resolve issue "cust date is set to some date and then mainfilter is selected then cust date is setback to current date..expected value is it should not change on mainfilter selection."
        //rows[0].CustomDateTime
        //this.commonFilterService.mainFilter_ContainsCustDate.subscribe(res => {
        //  //// set value(true/false) if selected mainfilter has customdate time, so that custome date control is disabled accordingly
        //  if (!res) {
        //    let selectedTime: any;
        //    selectedTime = { startDate: moment(), endDate: moment() };
        //    let custDates = selectedTime.startDate.format('MM/DD/YYYY HH:mm:ss') + ' - ' + selectedTime.endDate.format('MM/DD/YYYY HH:mm:ss');//this.dateStartInput.nativeElement.value;
        //    this.commonFilterService.TSBetween.subscribe(res => custDates = res);
        //    this.commonFilterService.setMFCustDT(custDates.replace('^', ';'));
        //    //////alert(custDates);
        //    this.commonFilterService.setDatesProperties(custDates.replace(';', '^'));
        //  }
        //  else {

        //  }
        //});
        rows.every(row => {
          //this.setConfigFromDB(row);
          return false;
        });
      });
    }

  }

  GetTimeZoneDatePeriod(mainFilterID) {
    //debugger;
    //////alert(4);
    let selectedTime: any;
    selectedTime = { startDate: moment(), endDate: moment() };

    let custDates = selectedTime.startDate.format('MM/DD/YYYY HH:mm:ss') + ' - ' + selectedTime.endDate.format('MM/DD/YYYY HH:mm:ss');//this.dateStartInput.nativeElement.value;
    //this.commonFilterService.TSBetween.subscribe(res => custDates = res);

    this.service.GetTimeZoneDatePeriod_Service(mainFilterID, custDates).subscribe((res) => {
      const rows = JSON.parse(res);

      //debugger;
      if (rows != ";")
        this.commonFilterService.setMFCustDT(rows);
      else {
        // this.commonFilterService.TSBetween.subscribe(res => custDates = res);
        // this.commonFilterService.setMFCustDT(custDates.replace('^', ';'));
        //this.commonFilterService.setDatesProperties(custDates);
        //this.commonFilterService.setDates(custDates);
        //this.commonFilter.setCommonFilters("Custom range");
        //this.commonFilter1.SetCustomDateTime();
      }
      //console.log(rows);
    });
  }

  wrongFilter = false;
  onFilterOFFClicked() {
    this.wrongFilter = false;
    this.FilterOFF = !this.FilterOFF;
    if (this.FilterOFF) {
      // this.ismainFilterEnabled = false;
      if (this.inputLengthFilter == 0) {
        this.triggerCollection.forEach((x, i) => {
          if (i == 0) {
            let firstSelectedOption = x.autocomplete.options.find(o => o.value.ID == this.selectedFilters);
            if (firstSelectedOption) {
              //this.FilterClose = true;
              this.controlFilter.setValue("");
              firstSelectedOption.deselect();
            }
          }
        });
      }
      this.FilterOFF = !this.FilterOFF;
      this.onFilterChange(0, false);
      this.FilterOFF = !this.FilterOFF;
    }
    else {
      //this.ismainFilterEnabled = true;
      let filterSelID = this.filtersList.find(m => m.CriteriaName == this.inputCtrl.nativeElement.value);
      this.selectedFilters = 0;
      if (filterSelID)
        this.selectedFilters = filterSelID.ID;
      else {
        this.FilterOFF = !this.FilterOFF;
        this.wrongFilter = true;
        return;
      }
      this.onFilterChange(this.selectedFilters, false);
    }
  }


  displayFnFilter(selectItem: any): string {
    return selectItem && selectItem.CriteriaName && !selectItem.CriteriaName.includes('--Select Filter--') ? selectItem.CriteriaName : '';
  }

  _FilterName(value: any): any[] {
    let FilterNameValue = '';
    if (typeof value === "string") {
      this.toHighlight = value;
      FilterNameValue = value.toLowerCase();
    }
    else {
      this.toHighlight = value.CriteriaName;
      FilterNameValue = value.CriteriaName.toLowerCase();
    }

    return this.filtersList.filter(option => option.CriteriaName.toLowerCase().includes(FilterNameValue) || option.CriteriaName.includes('--Select Filter--'));
  }

  getListFilter() {
    this.filterNamesObservable = this.filtersList;

    if (this.myConfigNameFilter != "null" && this.initFilter)
      this.setConfigByNameFilter(this.myConfigNameFilter);
  }
  setConfigByNameFilter(name) {
    this.modelFilterName = name;
    //this.ResetPage();
    //console.log(this.modelFilterName)
    let FilterConfigName = this.modelFilterName.trim();
    //this.resetCritErrors();
    if (FilterConfigName.length == 0) {
      this.onFilterChange(null, false);
      return;
    }

    let found = this.filtersList.find(x => x.name == FilterConfigName);
    if (found) {
      let id = found.id;
      this.onFilterChange(id, false);
    }

    this.initFilter = false;
  }

  inputLengthFilter = 0;
  setLimitedOptions = true;
  onKeydownMainFilter($event) {
    this.wrongFilter = false;
    if (!this.setLimitedOptions) {
      this.setLimitedOptions = true;
      this.controlFilter.valueChanges.subscribe(newValue => {
        this.filterNamesObservable = this._FilterName(newValue);
      })
    }
    this.inputLengthFilter = $event.target.value.length;
    this.modelFilterName = $event.target.value;
    if (this.inputLengthFilter == 0 && this.FilterOFF) {
      this.triggerCollection.forEach((x, i) => {
        if (i == 0) {
          let firstSelectedOption = x.autocomplete.options.find(o => o.value.ID == this.selectedFilters);
          if (firstSelectedOption) {
            //this.FilterClose = true;
            this.controlFilter.setValue("");
            firstSelectedOption.deselect();
          }
        }
      });
    }
  }
  clearInputTextFilter() {
    this.controlFilter.setValue("");
    this.inputLengthFilter = 0;
  }
  clearInputFilter(auto: MatAutocomplete) {
    this.clearInputTextFilter();
    this.selectedFilters = 0;
    this.modelFilterName = "";
    //input.placeholder = '';
    //input.value = '';
    //auto.options.forEach(option => option.deselect());
    //auto.closePanel();
    this.onFilterChange(null, false, false);
    //if (this.myConfigNameFilter != "null") {
    //  this.triggerCollection.forEach((x, i) => {
    //    if (i == 0)
    //      setTimeout(() => x.openPanel());
    //  });
    //}
  }

  openOrCloseFilter = false;
  //FilterClose = false;
  OpenAutoCompeleteDailogFilter(init?, closed?) {
    //const input = document.getElementById('message') as HTMLInputElement;
    //input.focus();
    let tmOut = 0;
    if (init)
      tmOut = 1000;
    else {
      this.setLimitedOptions = false;
      this.filterNamesObservable = this.filtersList;
    }
    this.triggerCollection.forEach((x, i) => {
      if (i == 0) {
        if (this.openOrCloseFilter == true || closed) {
          setTimeout(() => x.closePanel());
          this.openOrCloseFilter = false;
        }
        else {
          setTimeout(() => {
            this.inputCtrl.nativeElement.blur();
            this.inputCtrl.nativeElement.focus();
            this.toHighlight = this.inputCtrl.nativeElement.value;
            if (this.inputLengthFilter > 0) {
              //https://stackoverflow.com/a/76496095
              let firstSelectedOption = x.autocomplete.options.find(o => o.selected);
              if (this.mainFilterCloseChk) {
                firstSelectedOption = x.autocomplete.options.find(o => o.value.ID == this.selectedFilters);
                if (firstSelectedOption) {
                  firstSelectedOption.select();
                  setTimeout(() => {
                    x.openPanel();
                    firstSelectedOption._getHostElement().scrollIntoView({
                      block: 'center',
                    });
                  });
                }
                this.mainFilterCloseChk = false;
              }

              if (firstSelectedOption) {
                firstSelectedOption._getHostElement().scrollIntoView({
                  block: 'center',
                });
              }
            }

            //x.openPanel();
          }, tmOut);
          this.openOrCloseFilter = true;
        }
      }
    });
  }
}
